import MainLayout from "../../layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import DeleteModal from "../../components/modal/delete-modal";
import { TextView } from "../../components/view-form-components/text-view";
import { useEffect } from "react";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import ApproveRejectModal from "../../components/modal/approve-reject-modal";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import ShareModal from "../../components/modal/share-modal";

const ViewEmployeeRequest = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();

  const permission = state?.role?.employee_request;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [approveModalShow, setapproveModalShow] = useState(false);
  const [rejectModalShow, setRejectModalShow] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/employee-request/view`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteFnc = (id) => {
    api
      .post(`/employee-request/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/employee-request/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const UpdateApproveStatusFnc = () => {
    var status = {
      id: params?.id,
      status: "approved",
    };

    api
      .post(`/employee-request/update-status`, status)
      .then((response) => {
        successToast(response.message);
        navigate(`/employee-request/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const UpdateRejectStatusFnc = () => {
    var status = {
      id: params?.id,
      status: "rejected",
    };

    api
      .post(`/employee-request/update-status`, status)
      .then((response) => {
        successToast(response.message);
        navigate(`/employee-request/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  return (
    <MainLayout>
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="employee_request"
        modulelabel="employee_request"
      />
      <ApproveRejectModal
        type="approve"
        isOpen={approveModalShow}
        onClose={() => {
          setapproveModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
        approveBtnFnc={UpdateApproveStatusFnc}
      />
      <ApproveRejectModal
        type="reject"
        isOpen={rejectModalShow}
        onClose={() => {
          setRejectModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
        rejectBtnFnc={UpdateRejectStatusFnc}
      />
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">
            employee request - view
          </h2>
          {data?.status === "draft" ? (
            <div className="flex gap-3 items-center">
              {permission?.write && (
                <button
                  onClick={() => {
                    setShareModalShow(true);
                  }}
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  share
                </button>
              )}
              {permission?.write && (
                <Link
                  className="px-4 py-2 bg-blue-600 text-white rounded"
                  to={`/employee-request/edit/${params?.id}`}
                >
                  edit
                </Link>
              )}
              {permission?.write && (
                <button
                  onClick={() => {
                    setdeleteModalShow(true);
                  }}
                  className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
                >
                  Delete
                </button>
              )}
            </div>
          ) : (
            <div className="flex gap-3 items-center">
              {permission?.write && (
                <button
                  onClick={() => {
                    setShareModalShow(true);
                  }}
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  share
                </button>
              )}
              {permission?.write && state?.role?.type === "admin" && (
                <button
                  onClick={() => {
                    setapproveModalShow(true);
                  }}
                  className="px-4 py-1 bg-secondary border-[2px] border-secondary text-white rounded"
                >
                  Approve
                </button>
              )}
              {permission?.write && (
                <button
                  onClick={() => {
                    setRejectModalShow(true);
                  }}
                  className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
                >
                  Reject
                </button>
              )}
            </div>
          )}
        </div>
        <section className="w-full max-w-[40rem]">
          <div className="px-2">
            <TextView label={"Customer id"} value={data?.customer_id ?? "--"} />
          </div>
          <div className="px-2">
            <TextView
              label={"Customer Name"}
              value={data?.customer?.name ?? "--"}
            />
          </div>
          <div className="px-2">
            <TextView
              label={"customer_delivery_address id"}
              value={data?.customer_delivery_address ?? "--"}
            />
          </div>
          <div className="px-2">
            <TextView
              label={"customer delivery address"}
              value={data?.customerDeliveryAddress?.name ?? "--"}
            />
          </div>
          <div className="px-2">
            <TextView label={"description"} value={data?.description ?? "--"} />
          </div>
          <div className="px-2">
            <TextView label={"status"} value={data?.status ?? "--"} />
          </div>

          <CommentsComponent
            tableName={"employee_request"}
            viewId={params?.id}
          />
          <FileCommentComponent
            tableName={"employee_request"}
            viewId={params?.id}
          />
        </section>
      </section>
    </MainLayout>
  );
};

export default ViewEmployeeRequest;
